import { telemetryUrl } from "../urls";

export function redactUrlProperties(properties: object): void {
  const entries: readonly [string, unknown][] = Object.entries(properties);

  for (const [key, value] of entries) {
    if (typeof value === "string" && /url|href|referrer/i.test(key)) {
      Reflect.set(properties, key, telemetryUrl(value));
    } else if (
      (key === "$set" || key === "$set_once") &&
      value &&
      typeof value === "object"
    ) {
      redactUrlProperties(value);
    }
  }
}
